import React from "react";
import { useParams, Link, Navigate } from "react-router-dom";
import { legal, legalNav } from "../mock";
import Reveal from "../components/Reveal";

export default function Legal() {
  const { slug } = useParams();
  const doc = legal[slug];

  if (!doc) return <Navigate to="/legal/privacy-policy" replace />;

  return (
    <div>
      {/* HERO */}
      <section className="relative pt-40 pb-16 hero-atmosphere overflow-hidden">
        <div className="grain" />
        <div className="container-x max-w-4xl relative z-10">
          <Reveal>
            <p className="eyebrow mb-5">Legal</p>
          </Reveal>
          <Reveal delay={80}>
            <h1 className="font-display uppercase text-4xl md:text-6xl text-foreground leading-none">
              {doc.title}
            </h1>
          </Reveal>
          <Reveal delay={140}>
            <p className="text-muted-foreground mt-4 text-sm">{doc.updated}</p>
          </Reveal>
        </div>
      </section>

      {/* BODY */}
      <section className="section-pad bg-[#0c0b08]">
        <div className="container-x grid grid-cols-1 lg:grid-cols-[240px_1fr] gap-12">
          {/* Side nav */}
          <aside className="lg:sticky lg:top-28 h-max">
            <p className="eyebrow mb-5">Documents</p>
            <ul className="space-y-3">
              {legalNav.map((l) => (
                <li key={l.slug}>
                  <Link
                    to={`/legal/${l.slug}`}
                    className={`text-sm transition-colors ${
                      l.slug === slug ? "text-gold" : "text-foreground/70 hover:text-gold"
                    }`}
                  >
                    {l.label}
                  </Link>
                </li>
              ))}
            </ul>
          </aside>

          {/* Content */}
          <div className="max-w-2xl">
            {doc.sections.map((sec, i) => (
              <Reveal key={i} delay={i * 40}>
                <div className="mb-10">
                  <h2 className="font-display uppercase tracking-wide text-xl text-gold mb-4">
                    {sec.heading}
                  </h2>
                  {(sec.body || []).map((p, j) => (
                    <p key={j} className="text-muted-foreground leading-relaxed mb-4">
                      {p}
                    </p>
                  ))}
                  {sec.list && (
                    <ul className="list-none space-y-2 mb-4">
                      {sec.list.map((item, k) => (
                        <li key={k} className="text-muted-foreground leading-relaxed pl-5 relative">
                          <span className="absolute left-0 top-2 w-1.5 h-1.5 rounded-full bg-gold" />
                          {item}
                        </li>
                      ))}
                    </ul>
                  )}
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
}
